import Vue from 'vue';

Vue.component('vuetable_pricebook', () =>
    import(/* webpackChunkName: 'pricebook-index' */ './pricebook-index.vue'),
);

Vue.component('vuepricebook', () =>
    import(/* webpackChunkName: 'pricebook-details' */ './pricebook-details.vue'),
);
